import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section id="hero" className="relative overflow-hidden border-b border-slate-200/80 pt-24 sm:pt-28">
      <div className="site-container py-14 sm:py-16 lg:py-20">
        <div className="grid items-center gap-12 lg:grid-cols-[0.78fr_1.22fr] lg:gap-14">
          <div className="max-w-xl">
            <p className="section-kicker">One workspace. Better organized medicine.</p>
            <h1 className="text-4xl font-semibold leading-[1.05] tracking-[-0.045em] text-slate-900 sm:text-5xl lg:text-[3.5rem]">
              Medical knowledge, shaped around the way you learn.
            </h1>
            <p className="section-copy mt-6 max-w-lg text-lg">
              Bring trusted resources, focused modules, personal notes, and practical
              learning tools together in a library that stays useful as your needs evolve.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="https://1medicine.app"
                target="_blank"
                rel="noopener noreferrer"
                className="primary-button"
              >
                Start building your library
                <svg aria-hidden="true" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17 17 7M7 7h10v10" />
                </svg>
              </a>
              <a href="#how-it-works" className="secondary-button">
                See how it works
                <svg aria-hidden="true" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m6 9 6 6 6-6" />
                </svg>
              </a>
            </div>

            <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 border-t border-slate-200 pt-5 text-sm text-slate-600">
              <span className="inline-flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" aria-hidden="true" />
                Structured modules
              </span>
              <span className="inline-flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" aria-hidden="true" />
                Your own library
              </span>
              <span className="inline-flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" aria-hidden="true" />
                Web, iOS &amp; Android
              </span>
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-3xl lg:max-w-none">
            <div className="absolute -inset-4 rounded-[1.5rem] bg-emerald-100/60 sm:-inset-6" aria-hidden="true" />
            <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-2 shadow-[0_24px_70px_rgba(31,41,35,0.12)] sm:p-3">
              <div className="mb-2 flex items-center gap-1.5 px-1 py-1 sm:mb-3">
                <span className="h-2 w-2 rounded-full bg-slate-300" />
                <span className="h-2 w-2 rounded-full bg-slate-300" />
                <span className="h-2 w-2 rounded-full bg-emerald-400" />
                <span className="ml-2 text-[10px] font-medium uppercase tracking-[0.16em] text-slate-400">
                  Your 1MED workspace
                </span>
              </div>
              <img
                src="/assets/1medui.png"
                alt="1MEDICINE workspace showing organized clinical modules"
                className="block h-auto w-full rounded-lg border border-slate-100"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;